var exports = {
  "k": "xe564cbfb--4b0cd4--container",
};

module.exports = exports;
